module.exports = __webpack_public_path__ + "static/media/editimage.b3193484.png";